export function ImportDeckModal({ open, busy, error, onClose, onSubmit }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/80 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="import-deck-title"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg rounded-lg border border-slate-700 bg-slate-900 p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="import-deck-title" className="text-lg font-semibold text-slate-100">
          Import deck from RingsDB
        </h2>
        <p className="mt-2 text-sm text-slate-400">
          Paste a public decklist URL from ringsdb.com (for example{" "}
          <span className="text-slate-300">https://ringsdb.com/decklist/view/12345</span>).
        </p>
        <form
          className="mt-4"
          onSubmit={(e) => {
            e.preventDefault();
            const url = new FormData(e.currentTarget).get("url")?.toString().trim();
            if (url) void onSubmit(url);
          }}
        >
          <label className="block text-sm font-medium text-slate-300" htmlFor="ringsdb-import-url">
            Decklist URL
          </label>
          <input
            id="ringsdb-import-url"
            name="url"
            type="text"
            inputMode="url"
            autoComplete="off"
            required
            disabled={busy}
            placeholder="https://ringsdb.com/decklist/view/…"
            className="mt-2 w-full rounded-md border border-slate-600 bg-slate-950 px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:border-amber-500/60 focus:outline-none focus:ring-1 focus:ring-amber-500/40 disabled:opacity-50"
            autoFocus
          />
          {error && (
            <p className="mt-3 text-sm text-red-300" role="alert">
              {error}
            </p>
          )}
          <div className="mt-6 flex flex-wrap justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              disabled={busy}
              className="rounded-md border border-slate-600 px-4 py-2 text-sm text-slate-200 hover:bg-slate-800 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={busy}
              className="rounded-md border border-amber-600/70 bg-amber-950/90 px-4 py-2 text-sm font-medium text-amber-100 hover:bg-amber-900 disabled:opacity-50"
            >
              {busy ? "Importing…" : "Import deck"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
